<template>
    <div class="container h-100">
        <div class="img">
            <img src="../assets/logo.jpg" alt="" class="d-block img-logo">
        </div>
        <div class="row h-100 align-items-center">
            <div class="col-12 col-md-6 offset-md-3">
                <div class="card shadow sm">
                    <div class="card-body">
                        <h2 class="text-center">Account</h2>
                        <hr />
                        <form action="javascript:void(0)" method="post">
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label">* Email</label>
                                <input type="email" v-model="email" name="email" id="email" class="form-control" required>
                            </div>
                            <div class="d-flex justify-content-between">
                                <button type="submit" :disabled="processing" @click="send()" class="btn btn-primary mb-3 ">
                                    {{ processing ? "Please wait" : "Send" }}
                                </button>
                            </div>         
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import * as notificationService from '../services/notification_service'

export default {
    name:"login",
    data(){
        return {
            email : '',
            validationErrors: '',
            processing : false
        }
    },
    methods:{  
        
        async send() {
            try {
                this.processing = true;
                const send = await notificationService.sendNotification(this.email);
                const message = send.data.message;

                if (send.data.success) {
                    this.makeToast('Success', message, 'success');
                    this.processing = false;
                    this.email = '';
                }               

            } catch (error) {
                if (error.response && error.response.status == 422) {
                    this.validationErrors = error.response.data.errors['email'][0]
                    this.makeToast('Warning', this.validationErrors, 'warning');
                    this.processing = false;
                }else{
                    this.makeToast('Error', 'Something went wrong', 'error');
                    this.processing = false;
                }
            }
                
        },
        
        makeToast(title, text, type) {
            this.toastCount++
            this.$bvToast.toast(text, {
                title: title,
                variant: type,
                autoHideDelay: 2000,
                appendToast: true
            })
        },
         
    }
}
</script>
